var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { calculateColumnsRelativeToParent } from './calculate-columms-relative-to-parent';
export const normaliseDeviceBreakpoints = (component, parentDeviceBreakpoints) => {
    var _a;
    const componentDeviceBreakpoints = ((_a = component.cqResponsive) === null || _a === void 0 ? void 0 : _a.deviceBreakpoints) || component.deviceBreakpoints;
    const { cqResponsive } = component, restComponent = __rest(component, ["cqResponsive"]);
    return Object.assign(Object.assign({}, restComponent), { deviceBreakpoints: parentDeviceBreakpoints && componentDeviceBreakpoints
            ? calculateColumnsRelativeToParent(componentDeviceBreakpoints, parentDeviceBreakpoints)
            : componentDeviceBreakpoints });
};
//# sourceMappingURL=normalise-device-breakpoints.js.map